import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivities = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7783 14.035L14.0342 17.779C13.8253 17.988 13.5772 18.1538 13.3041 18.267C13.031 18.3801 12.7383 18.4383 12.4427 18.4382H3.8125C3.21576 18.4382 2.64347 18.2012 2.22151 17.7792C1.79955 17.3573 1.5625 16.785 1.5625 16.1882V3.81323C1.5625 3.2165 1.79955 2.6442 2.22151 2.22224C2.64347 1.80029 3.21576 1.56323 3.8125 1.56323H16.1875C16.7842 1.56323 17.3565 1.80029 17.7785 2.22224C18.2004 2.6442 18.4375 3.2165 18.4375 3.81323V12.4435C18.4375 12.7391 18.3793 13.0317 18.2662 13.3048C18.1531 13.5779 17.9873 13.826 17.7783 14.035V14.035Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8125 18.4075V15.0632C12.8125 14.4665 13.0496 13.8942 13.4715 13.4722C13.8935 13.0503 14.4658 12.8132 15.0625 12.8132H18.4067",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 5.625H13.5",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 10H13.5",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 14.375H10",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgActivities);
export default ForwardRef;
